import { ApiRoutes } from '@/services/ApiRoutes.js';
import { BackendAPI } from '@/services/BackendAPI.js';

export default {
  sendInquiry(data) {
    return BackendAPI('post', ApiRoutes.mail.sendInquiry(), data);
  },
};
